
const base  =  '/admin'

export const adminUrls = {
    adminHome: base,
    adminCertificates: base + '/certificates'
};